const stickyWithHeaderEls = document.querySelectorAll("[data-js='sticky-with-header']");
const headerElement = document.getElementById("header") || document.getElementById("header-sticky");

if (headerElement) {
  updateStickyHeaderTop(headerElement.clientHeight); // Adds offset on page load since header will always be shown.

  headerElement.addEventListener("header-toggled", () => {
    const headerHeight = Math.abs(parseInt(headerElement.style.top));

    updateStickyHeaderTop(headerHeight);
  });

  function updateStickyHeaderTop(top) {
    stickyWithHeaderEls.forEach((stickyWithHeaderEl) => {
      stickyWithHeaderEl.style.top = `calc(${top}px + 1rem)`;
    });
  }
}
